"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackJSAgent = exports.TrackJSServer = exports.TrackJS = void 0;
const trackjs_1 = require("trackjs");
Object.defineProperty(exports, "TrackJS", { enumerable: true, get: function () { return trackjs_1.TrackJS; } });
const TrackJSAgent_1 = require("./TrackJSAgent");
Object.defineProperty(exports, "TrackJSAgent", { enumerable: true, get: function () { return TrackJSAgent_1.TrackJSAgent; } });
const TrackJSServer = null;
exports.TrackJSServer = TrackJSServer;
